// ======================================================================
// File Name       : DistributionServiceList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { CONTENT_DISTRIBUTION } from '../../constants/PathConstants';
import TableHead, { setSortState } from '../TableHead';
import { getItemBoxName } from '../../utils/index';
import { getDistributionTypeName } from '../../utils/ContentDistributionUtils';
import { CONTENT_DISTRIBUTION_STATUS } from '../../constants/ContentDistributionConstant';
import { IS_SHOW_MENU_DEVELOP_FEATURE_51 } from '../../constants/index';
import PaginationCustom from '../Pagination';
import CustomLink from '../button/CustomLink';

const DistributionServiceList = ({ distributionServiceListInfo, handleSortState, dataSort, recordNum, getStartEndData, startPosition, hoverIndex, handleMouseEnter, handleMouseLeave }) => {
  const thead = IS_SHOW_MENU_DEVELOP_FEATURE_51 ?
  [
    { title: '配布先サービス名', sortBy: 0 },
    { title: '配布コース数', sortBy: 2}, // Need to change later
    { title: '配布コンテンツ数', sortBy: 3},
    { title: 'コンテンツ種別', sortBy: null},
    { title: 'ステータス', sortBy: 4},
    { title: '操作', sortBy: null},
  ]
  : [
    { title: '配布先サービス名', sortBy: 0 },
    { title: '配布コンテンツ数', sortBy: 3},
    { title: '配布種別', sortBy: null},
    { title: 'ステータス', sortBy: 4},
    { title: '操作', sortBy: null},
  ];
  let data = thead;
  if (dataSort) {
    const sortBy = dataSort.distributionServiceSortType;
    const sortState = dataSort.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }
  let distributionServiceList = null;
  if (distributionServiceListInfo && distributionServiceListInfo.distributionServiceList) {
    distributionServiceList =
    distributionServiceListInfo.distributionServiceList.map((distributionService, index) => {
      const linkContentList = `/${CONTENT_DISTRIBUTION}/offerList/${distributionService.serviceCd}`;
      const linkUsageSituation = `/${CONTENT_DISTRIBUTION}/usageDetail/${distributionService.serviceCd}`;
      return (
        <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
          <td>
            {distributionService.serviceName}
          </td>
          {IS_SHOW_MENU_DEVELOP_FEATURE_51 && <td className="text-right">
            {distributionService.distributionCourseNum || 0}
          </td>}
          <td className="text-right">
            {distributionService.distributionContentNum || 0}
          </td>
          <td>
            {getDistributionTypeName(distributionService)}
          </td>
          <td>
            {getItemBoxName(CONTENT_DISTRIBUTION_STATUS, distributionService.distributionStatus)}
          </td>
          <td className="text-center">
            <div className="inline-flex">
              <CustomLink
                className="margin-right-7 btn-edit margin-right-10"
                to={linkContentList}
                text="コンテンツ一覧"
              />
              <CustomLink
                className="margin-right-7 btn-edit"
                to={linkUsageSituation}
                text="利用状況"
              />
            </div>
          </td>
        </tr>
      );
    });
  }
  return (
    <div id="distributionServiceListTable">
      <Table striped hover>
        <thead>
          <TableHead data={data} handleSortState={handleSortState} />
        </thead>
        <tbody>
          {distributionServiceList}
        </tbody>
      </Table>
      <Col sm={12} className="padding-left-right-clear d-flex justify-content-center">
        <PaginationCustom
          className="text-center"
          recordNum={recordNum}
          handlePageSelect={getStartEndData}
          startPosition={startPosition}
        />
      </Col>
    </div>
  );
};

export default DistributionServiceList;
